<template>
  <div class="page-container">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="200px"
      class="changePwd"
    >
      <el-form-item label="当前登录用户" prop="">
        <el-input v-model="userName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="当前密码" prop="password">
        <el-input
          v-model="form.password"
          placeholder="请输入当前密码"
          show-password
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="form.newPassword"
          placeholder="请输入新密码"
          oninput="value=value.replace(/[\ ]/,'')"
          show-password
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input
          placeholder="请确认新密码"
          v-model="form.confirmPassword"
          oninput="value=value.replace(/[\ ]/,'')"
          show-password
          maxlength="50"
        ></el-input>
      </el-form-item>
      <div class="form-footer">
        <el-button type="primary" @click="saveForm">保 存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { adminChangePwd } from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      isShowNode: true,
      form: {
        userType: 1,
        userId: "",
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
      userName: "",
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        password: [
          { required: true, validator: this.testPassword, trigger: "blur" },
        ],
        newPassword: [
          { required: true, validator: this.testNewPassword, trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            validator: this.testRepeatPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    close() {},
    isExpand() {
      this.isShowNode = !this.isShowNode;
      console.log(this.isShowNode);
    },
    testPassword(rule, value, callback) {
      if (value) {
        if (value.length > 20 || value.length < 6) {
          callback(new Error("请输入6~20位密码"));
        }
        callback();
      } else {
        callback(new Error("请输入当前密码"));
      }
    },
    testNewPassword(rule, value, callback) {
      if (value) {
        if (value.length > 20 || value.length < 6) {
          callback(new Error("请输入6~20位密码"));
        }
        callback();
      } else {
        callback(new Error("请输入新密码"));
      }
    },
    testRepeatPassword(rule, value, callback) {
      if (value) {
        if (value.length > 20 || value.length < 6) {
          callback(new Error("请输入6~20位密码"));
        }
        callback();
      } else {
        callback(new Error("请重复输入新密码"));
      }
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.newPassword !== this.form.confirmPassword) {
            this.$message.error("两次输入新密码不一致");
            return;
          }
          this.form.userId = JSON.parse(
            window.sessionStorage.getItem("userData")
          ).userId;
          var params = this.form;
          adminChangePwd(params).then((res) => {
            if (res.errorCode == 200) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.$nextTick(() => {
                this.$refs["form"].resetFields();
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
  created() {},
  mounted() {
    this.userName = JSON.parse(window.sessionStorage.userData).userName;
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .changePwd {
    padding: 20px 50px;
    background-color: #ffffff;
    border-radius: 6px;
    margin-top: 20px;
  }
  .form-footer {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/baseInfoManage/changePassword.vue